<template>
  <div id="app" :class="classIndex">
    <loader></loader>
    <app-welcome v-if="userLogged.profile == 'HIJO'"></app-welcome>
    <app-arkidians v-if="userLogged.profile == 'PADRE'"></app-arkidians>
    <app-continue-watching v-if="userLogged.profile == 'HIJO'"></app-continue-watching>
    <app-inicial v-if="!userLogged.profile"></app-inicial>
    <app-proyectos v-if="!userLogged.profile"></app-proyectos>
    <app-categories-grid v-if="userLogged.profile != 'ADMINISTRADOR'"></app-categories-grid>
    <app-challenge v-if="!userLogged.profile"></app-challenge>
    <app-share v-if="!userLogged.profile"></app-share>
    <app-benefits v-if="!userLogged.profile"></app-benefits>
    <app-comments v-if="!userLogged.profile"></app-comments>
    <app-faqs v-if="!userLogged.profile"></app-faqs>
    <app-footer v-if="!userLogged.profile"></app-footer>
    <app-admin v-if="userLogged.profile == 'ADMINISTRADOR'"></app-admin>
    <app-latest-challenges v-if="userLogged.profile == 'HIJO'"></app-latest-challenges>

  </div>
</template>

<script>
import Loader from "./shared/Loader";
import Welcome from "../components/startPage/Welcome";
import ContinueWatching from "../components/startPage/ContinueWatching";
import CategoriesGrid from "../components/categories/CategoriesGrid.vue";
import Inicial from "../components/startPage/InicialConRegistro";
import ProjectBanner from "../components/startPage/ProjectBanner";
import ChallengeBanner from "../components/startPage/ChallengeBanner";
import ShareBanner from "../components/startPage/ShareBanner";
import BenefitsBanner from "../components/startPage/BenefitsBanner";
import CommentsBanner from "../components/startPage/CommentsBanner";
import Faqs from "../components/startPage/Faq";
import Footer from "../components/startPage/Footer";
import AdminPanel from "../components/admin/AdminPanel";
import LatestChallenges from "../components/startPage/LatesChallenges";
import Arkidians from "../components/startPage/Arkidians";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      classIndex: ""
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["categorias", "userLogged"])
  },
  components: {
    Loader: Loader,
    appCategoriesGrid: CategoriesGrid,
    appInicial: Inicial,
    appProyectos: ProjectBanner,
    appChallenge: ChallengeBanner,
    appShare: ShareBanner,
    appBenefits: BenefitsBanner,
    appComments: CommentsBanner,
    appFaqs: Faqs,
    appFooter: Footer,
    appAdmin: AdminPanel,
    appWelcome: Welcome,
    appContinueWatching: ContinueWatching,
    appLatestChallenges: LatestChallenges,
    appArkidians: Arkidians,
  },

  mounted: function() {

    if (this.userLogged.profile == "HIJO") {
      this.classIndex = "index-kids";
    }else if (this.userLogged.profile == "PADRE"){
      this.classIndex = "index-other";
    }
    const loader = document.querySelector(".loader");
    loader.className += " hidden";
  }
};
</script>

<style>
#welcome {
  background: url("/public/images/site/background-welcome.svg") no-repeat 50%
    50%;
  background-color: #0cb9c9;
  display: table;
  height: 100%;
  width: 100%;
  background-position-y: bottom;
  background-size: cover;
}

.index-kids {
  background-image: url(/public/images/site/index-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}

.index-other {
  background-image: url(/public/images/site/index-other-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}

.profile-background {
  background-image: url(/public/images/site/profile-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeRegistro.vue